<template>
  <div>
    <div style="height:calc(100vh - 200px);overflow-y:auto;">
      <div v-for="(alert,index) in sanctions" :key="index">
        <RdcAlert :alert="alert" :alertIndex="index" class="my-3" v-if="eventCategories[alert.data.event.category] == alert.data.event.category"></RdcAlert>
      </div>
      <p class="my-5" v-if="sanctions.length ==0">
        <strong>No Sanctions or enforcement alerts were found</strong>
      </p>
    </div>
  </div>
</template>
<script>
import RdcAlert from "../../negative-media/RDCAlert.vue";
export default {
  name: "SanctionsEnforcementsAlertsComponent",
  components: {
    RdcAlert
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
  props: {
    sanctions: Array,
    eventCategories: Array,
    subEventCategories: Array
  }
};
</script>